module.exports = __webpack_public_path__ + "img/rush-logo.f7dde302.png";